/** Classes for rendering links like a button. */
export const clsButtonLikeLink = Object.freeze([
    'cg-btn btn-actionable-3 border-transparent justify-between',
    'min-h-9',
    'hover:no-underline',
    'bg-white/0 hover:bg-brand-1 dark:hover:bg-brand-65',
]);
const clsBase = Object.freeze([
    'min-h-9',
    'border-b-brand-40 dark:border-b-brand-10',
]);
/** Classes for the read-only inputs used in the login pages. */
export const clsReadOnlyInput = Object.freeze(clsBase);
/** Classes for the inputs used in the login pages. */
export const clsInput = Object.freeze([
    ...clsBase,
    'user-invalid:border-b-critical-40 dark:user-invalid:border-b-critical-10',
    'bg-brand-1 dark:bg-brand-60',
    'user-invalid:bg-critical-1 dark:user-invalid:bg-critical-60',
]);
